const prioritizedBlogPostTagList = [
  {id: 8856, value:'podcast'},
  {id: 196, value:'people'},
  {id: 8159, value:'off the beaten path'},
  {id: 8220, value:'escape to nature'},
  {id: 8154, value:'islands & peninsulas'},
  {id: 8157, value:'mountains & caves'},
  {id: 8158, value:'the urban experience'},
  {id: 110, value:'travel destinations'},
  {id: 8160, value:'travel tips'},
  {id: null, value:'travel guide'}
]

module.exports = {prioritizedBlogPostTagList}